import api from '@/services/api'
import type { AssetsResponse, AssetExchangeContractMinResponse } from './types.ts'

export const AssetsV2Service = {
  fetchAssets() {
    return api.get<AssetsResponse>(`/v2/assets`)
  },
  fetchAssetsContracts() {
    return api.get<AssetExchangeContractMinResponse[]>(`/v2/assets/contracts`)
  },
  fetchMyContracts() {
    return api.get<AssetExchangeContractMinResponse[]>(`/v2/assets/my-contracts`)
  },
  deleteMyContract(contractId: number) {
    return api.delete(`/v2/assets/my-contracts/${contractId}`)
  },
  fetchAssetsContractsByAsset(asset: string, marketType: string = 'swap') {
    return api.get<AssetExchangeContractMinResponse[]>(`/v2/assets/contracts-by-asset/${asset}?market_type=${marketType}`)
  },
}
